<template>
  <div>
    <HeroImage />

    <div style="margin-top: 0.5rem; padding-bottom: 3rem;">
      <div>
        <PCPage></PCPage>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import RootVue from "@/RootVue.vue";

import PCPage from "@/pages/_component/PCPage.vue";
import HeroImage from "@/component/HeroImage.vue";

@Options({
  components: {
    PCPage,
    HeroImage,
  },
})
export default class extends Vue {
  // @ts-expect-error
  $root: RootVue;

  created(){
    this.$root.restAccess.postStatistics("home")
  }
}
</script>

<style lang="scss" scoped>
.nav-side {
  // width: 19%;
  .nav {
    position: sticky;
    top: 68px;
  }
}

.mainpage_title {
  border-bottom: solid 3px #87cefa;
}
</style>
